import { createContext } from "react";

export type NotificationType = "success" | "danger" | "warning" | "neutral";

export interface Notification {
    id: string;
    message: string;
    type: NotificationType;
    duration?: number;
}

export interface NotificationContextType {
    showNotification: (message: string, type?: NotificationType, duration?: number) => void;
    showSuccess: (message: string, duration?: number) => void;
    showError: (message: string, duration?: number) => void;
    showWarning: (message: string, duration?: number) => void;
    showInfo: (message: string, duration?: number) => void;
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);
